import { authApiService } from '@/api/authApiService';
import { ApiResponseType } from '@/types/sharedTypes';

export const downloadRecipientProfilePDFAPi = (token: string): Promise<ApiResponseType<Blob>> =>
  authApiService.GET(`/vendor-vault/requests/${token}/pdf/?reveal=1`, null, {
    requestHeaders: {
      'Content-Type': 'application/pdf',
    },
  });
